import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import  { useRef } from 'react';
import emailjs from 'emailjs-com'
function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_xes37i8', 'template_995gmlp', form.current, 'j54qMQVovjA4-OZxd')
   e.target.reset()
  };
  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className='container contact__container'>
        <div className='contact__options'>
          <article className='contact__option'>
            <MdOutlineEmail className='contact__option-icon'/>
            <h4>Email</h4>
            <h5>ayoub.riadhii@gmail.com</h5>
            < a href='mailto:ayoub.riadhii@gmail.com' target='_blank'>Send a message </a>
          </article>
          <article className='contact__option'>
            <RiMessengerLine className='contact__option-icon'/>
            <h4>Messanger</h4>
            <h5>rayadi.ayoub</h5>
            < a href='https://m.me/rayadi.ayoub' target='_blank'>Send a message </a>
          </article> <article className='contact__option'>
            <BsWhatsapp className='contact__option-icon'/>
            <h4>Whatsapp</h4>
            <h5>+216-27-955-950</h5>
            < a href='https://api.whatsapp.com/send?phone+21627955950' target='_blank'>Send a message </a>
          </article>
        </div>
        {/* end of contact options */}
<form ref={form} onSubmit={sendEmail}>
  <input type='text' name='name' placeholder='Your Full Name' required/>
  <input type='email' name='emaill' placeholder='Your Email' required/>
  <textarea type='Message' rows="7" placeholder='Your Message' required></textarea>
<button type='submit' className='btn btn-primary' >Send Message</button>
</form>
      </div>
    </section>
  )
}

export default Contact
